import { makeBetterEnum } from './betterEnum';

export const BuildingSizeUnit = makeBetterEnum('SquareFeet', 'SquareMeters');

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type BuildingSizeUnit =
  (typeof BuildingSizeUnit)[keyof typeof BuildingSizeUnit];

export const BuildingLeaseType = makeBetterEnum(
  'Owned',
  'Leased',
  'DownstreamLeasePayingUtilities',
  'DownstreamLeaseNotPayingUtilities',
  'DownstreamSubleasePayingUtilities',
  'DownstreamSubleaseNotPayingUtilities',
  'UpstreamSublease',
  'CoworkingOrServicedOffice',
  'Franchise',
  'SoldBuilding',
  'Unknown'
);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type BuildingLeaseType =
  (typeof BuildingLeaseType)[keyof typeof BuildingLeaseType];

export const BuildingEditState = makeBetterEnum(
  'Partial',
  'Full',
  'NeedsConfirmation'
);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type BuildingEditState =
  (typeof BuildingEditState)[keyof typeof BuildingEditState];

export const BuildingPeriodKind = makeBetterEnum(
  'BuildingSize',
  'CleanPower',
  'IsBuildingEmpty',
  'CustomField',
  'PowerUsageEffectiveness',
  'OrgUnit'
);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type BuildingPeriodKind =
  (typeof BuildingPeriodKind)[keyof typeof BuildingPeriodKind];

export const BuildingUtilityUnit = makeBetterEnum(
  'M3NaturalGas',
  'Kbtu',
  'Mmbtu',
  'Therm',
  'Ccf',
  'Mcf',
  'Cf',
  'Gj',
  'Mj',
  'Oz',
  'Gallons',
  'Liter',
  'Kwh',
  'Kw',
  'Joule',
  'G',
  'Kg',
  'Lb',
  'Tonnes',
  'Tons',
  'CubicMeter',
  'Kilogallon',
  'Centigallon'
);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type BuildingUtilityUnit =
  (typeof BuildingUtilityUnit)[keyof typeof BuildingUtilityUnit];

export const BuildingWasteUnit = makeBetterEnum(
  'G',
  'Kg',
  'Lb',
  'Tonnes',
  'Tons'
);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type BuildingWasteUnit =
  (typeof BuildingWasteUnit)[keyof typeof BuildingWasteUnit];

export const BuildingUtilityType = makeBetterEnum(
  'ElectricityConsumption',
  'StationaryCombustion',
  'Waste',
  'Water',
  'Refrigerant'
);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type BuildingUtilityType =
  (typeof BuildingUtilityType)[keyof typeof BuildingUtilityType];
